'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _ArrowLeftOutlined = _interopRequireDefault(require('./lib/icons/ArrowLeftOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _ArrowLeftOutlined;
exports.default = _default;
module.exports = _default;